// material ui
import { Box, Divider, Typography } from '@mui/material';

// shared components
import { SuperuserOnly } from '@/components/access-control';

// relative
import AvatarComponent from '../components/appbar/user-menu/AvatarComponent';
import { useUserMenuState } from '../components/appbar/user-menu/useUserMenuState';
import NavigationFooterActions from './NavigationFooterActions';

interface NavigationFooterProps {
  drawerOpen: boolean;
  onOpenCookiePreferences: () => void;
}

export default function NavigationFooter({
  drawerOpen,
  onOpenCookiePreferences,
}: NavigationFooterProps) {
  const { t, email } = useUserMenuState();

  return (
    <Box
      sx={{
        flexShrink: 0,
        borderTop: '1px solid',
        borderColor: 'divider',
        p: drawerOpen ? 2 : 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: drawerOpen ? 'flex-start' : 'center',
          gap: 1.5,
        }}
      >
        <AvatarComponent string={email} />
        {drawerOpen && (
          <Box sx={{ minWidth: 0, overflow: 'hidden' }}>
            <Typography variant="body2" fontWeight={700} noWrap component="div">
              {email}
            </Typography>
            <Typography variant="body2" color="text.secondary" component="div">
              <SuperuserOnly
                fallback={t('toolbar.userRole', {
                  defaultValue: 'ReMoni User',
                })}
              >
                {t('toolbar.adminRole', {
                  defaultValue: 'ReMoni Admin',
                })}
              </SuperuserOnly>
            </Typography>
          </Box>
        )}
      </Box>
      <Divider sx={{ my: 1.5 }} />
      <NavigationFooterActions
        drawerOpen={drawerOpen}
        onOpenCookiePreferences={onOpenCookiePreferences}
      />
    </Box>
  );
}
